import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { interactionsTypeActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'
import LogsModal from './LogsModal'
import EditorFormatListBulleted from 'material-ui/svg-icons/editor/format-list-bulleted'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchInteractionsType, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchInteractionsType({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
    return true
  }

  componentDidMount() {
    const { fetchInteractionsType } = this.props
    fetchInteractionsType()
  }

  handleParsingString(term) {
    var str = term.join(', ')
    return str
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchInteractionsType, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchInteractionsType, handleChangePerPage, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = interactionType => {
    const {
      fetchInteractionType,
      deleteInteractionType,
      addConfirm,
      token,
      restoreInteractionType,
      openLogsModal,
      fetchLogs
    } = this.props

    return (
      <Fragment>
        {findPermission('logInteracoes', token).ler && (
          <IconButton
            onClick={() => {
              openLogsModal()
              fetchLogs(interactionType._id)
            }}
          >
            <EditorFormatListBulleted />
          </IconButton>
        )}

        {!!interactionType.deletedAt && findPermission('interacoes_tipo', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste tipo de interação?',
                confirmFunction: () => {
                  restoreInteractionType(interactionType._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('interacoes_tipo', token).editar && (
              <IconButton
                onClick={() => {
                  fetchInteractionType(interactionType._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('interacoes_tipo', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste tipo de interação?',
                    confirmFunction: () => {
                      deleteInteractionType(interactionType._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const {
      classes,
      interactionsType = [],
      loadingInteractionsType,
      pagination,
      order = {},
      openLogsModal,
      fetchLogs
    } = this.props
    return (
      <Fragment>
        <Paper className={classes.wrapperTable} elevation={4}>
          {!!loadingInteractionsType && (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          )}
          <Table
            fixedHeader={true}
            wrapperStyle={{
              display: 'flex',
              flexDirection: 'column',
              maxHeight: 'var(--crud-table-height)'
            }}
            width={'990px'}
          >
            <TableHeader
              displaySelectAll={false}
              className={classes.tableHeader}
              adjustForCheckbox={false}
            >
              <TableRow>
                <TableHeaderColumn>
                  <TableSortLabel
                    active={((order || {}).column || '') === 'nome'}
                    direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                    onClick={() => {
                      this.handleSortTable('nome')
                    }}
                  >
                    Nome
                  </TableSortLabel>
                </TableHeaderColumn>
                <TableHeaderColumn>
                  <TableSortLabel
                    active={((order || {}).column || '') === 'gravidade_id'}
                    direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                    onClick={() => {
                      this.handleSortTable('gravidade_id')
                    }}
                  >
                    Gravidade
                  </TableSortLabel>
                </TableHeaderColumn>
                <TableHeaderColumn>
                  <TableSortLabel
                    active={((order || {}).column || '') === 'efeito'}
                    direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                    onClick={() => {
                      this.handleSortTable('efeito')
                    }}
                  >
                    Efeito
                  </TableSortLabel>
                </TableHeaderColumn>
                <TableHeaderColumn>
                  <TableSortLabel
                    active={((order || {}).column || '') === 'probabilidade_id'}
                    direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                    onClick={() => {
                      this.handleSortTable('probabilidade_id')
                    }}
                  >
                    Probabilidade
                  </TableSortLabel>
                </TableHeaderColumn>
                <TableHeaderColumn style={{ width: '180px' }}>Ações</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {(interactionsType || []).length ? (
                (interactionsType || []).map(interactionType => {
                  return (
                    <TableRow key={interactionType._id}>
                      <TableRowColumn>{interactionType.nome}</TableRowColumn>
                      <TableRowColumn>{(interactionType.gravidade_id || {}).nome}</TableRowColumn>
                      <TableRowColumn>{interactionType.efeito}</TableRowColumn>
                      <TableRowColumn>
                        {(interactionType.probabilidade_id || {}).nome}
                      </TableRowColumn>
                      <TableRowColumn style={{ width: '187px' }}>
                        {this.renderActions(interactionType)}
                      </TableRowColumn>
                    </TableRow>
                  )
                })
              ) : (
                <TableRow>
                  <TableRowColumn>
                    <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                      {!!loadingInteractionsType ? 'Carregando...' : 'Não há registros.'}
                    </Typography>
                  </TableRowColumn>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <div className={classes.paginationWrapper}>
            <div className={classes.page}>Página: {pagination.page + 1}</div>
            <TablePagination
              component="div"
              className={classes.pagination}
              labelRowsPerPage="Itens por página"
              labelDisplayedRows={({ from, to, count, page }) => {
                return `Exibindo de ${from} a ${to} de ${count}`
              }}
              rowsPerPageOptions={[25, 50, 100]}
              count={pagination.length}
              rowsPerPage={pagination.rowsPerPage}
              page={pagination.page}
              backIconButtonProps={{
                'aria-label': 'Página anterior'
              }}
              nextIconButtonProps={{
                'aria-label': 'Próxima página'
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </div>
        </Paper>
        <LogsModal classes={classes} />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    interactionType: state.interactionsType.interactionType,
    interactionsType: state.interactionsType.interactionsType,
    loadingInteractionsType: state.interactionsType.loadingInteractionsType,
    token: state.auth.token,
    pagination: state.interactionsType.interactionsTypePagination,
    order: state.interactionsType.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(interactionsTypeActions.openModal())
    },
    closeModal: () => {
      dispatch(interactionsTypeActions.closeModal())
    },
    fetchInteractionType: id => {
      dispatch(interactionsTypeActions.fetchInteractionType(id))
    },
    fetchInteractionsType: options => {
      dispatch(interactionsTypeActions.fetchInteractionsType(options))
    },
    deleteInteractionType: id => {
      dispatch(interactionsTypeActions.deleteInteractionType(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(interactionsTypeActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(interactionsTypeActions.handleChangePerPage(perPage))
    },
    restoreInteractionType: id => {
      dispatch(interactionsTypeActions.restoreInteractionType(id))
    },
    changeOrderColumn: column => {
      dispatch(interactionsTypeActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(interactionsTypeActions.changeOrderDirection(direction))
    },
    fetchLogs: id => {
      dispatch(interactionsTypeActions.fetchLogs(id))
    },
    openLogsModal: () => {
      dispatch(interactionsTypeActions.openLogsModal())
    },
    closeLogsModal: () => {
      dispatch(interactionsTypeActions.closeLogsModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/InteractionsType/ListTable.js